// ink-component
import React from 'react';
import CoreSearch, { SearchProps as CoreSearchProps } from '../../../Search/Search';

export interface SearchProps extends Omit<CoreSearchProps, 'hasFilter'> {
  /** Unique identifier */
  id: string;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

/**
 * @purpose Search component for Ledger implementations
 * @group ledger
 * @categories table
 */
const Search = ({ ...otherProps }: SearchProps) => {
  return <CoreSearch placeholder="Search" hasClear {...otherProps} hasFilter={false} />;
};

Search.defaultProps = {
  id: undefined,
  'data-testid': undefined,
};

Search.displayName = 'LedgerWrapper.Search';

export default Search;
